@if (rotaAssignment()) {
  <div appHorizontalTimeSlot class="assignment"
       [gridStart]="gridStartHour()"
       [startTime]="rotaAssignment().startTime"
       [endTime]="rotaAssignment().endTime"
       [cellWidth]="cellWidth()">
    <div class="assignment-text">
      {{ rotaAssignment().startTime | timeParse | dateFormat: 'HH:mm' }}
      <ng-container *ngTemplateOutlet="assignmentDuration; context: {
                $implicit: getDurationInHours(rotaAssignment())}">
      </ng-container>
      {{ rotaAssignment().endTime | timeParse | dateFormat: 'HH:mm' }}
      <div class="role">
        {{ employee().role | enumParse }}
        @for (assignment of roleAssignments(); track assignment) {
          <span>& {{ assignment.role | enumParse }}:
            {{ assignment.startTime | timeParse | dateFormat: 'HH:mm' }} -
            {{ assignment.endTime | timeParse | dateFormat: 'HH:mm' }}
          </span>
        }
      </div>
    </div>
  </div>
}

<ng-template #assignmentDuration let-durationInHours>
  @if (durationInHours > 2) {
    <div class="d-inline-block">
      <div class="assignment-horizontal-line" [style.width.px]="(durationInHours - 2.5) * cellWidth() / 2"></div>
      {{ durationInHours }} hr
      <div class="assignment-horizontal-line" [style.width.px]="(durationInHours - 2.5) * cellWidth() / 2"></div>
    </div>
  } @if (durationInHours <= 2) {
  <span>-</span>
}
</ng-template>